<template>
  <div>
    <b-modal
      v-model="modalShow"
      title=""
      hide-footer
      size="xl"
      header-class="header-payment"
    >
      <template #modal-header>
        <div class="w-100 d-flex justify-content-between">
          <div class="my-auto">
            <strong class="title-modal">รายละเอียดการชำระเงิน</strong>
          </div>
          <div class="my-auto">
            <b-icon
              icon="x-circle-fill"
              class="float-right pointer"
              @click="hide"
            ></b-icon>
          </div>
        </div>
      </template>
      <div>
        <div>
          <b-row>
            <b-col class="payment-list">
              <PaymentList
                :bankAccountList="bankAccountList"
                :paymentDetailList="paymentDetailList"
                :paymentSelected="paymentSelected"
                :v="$v.formApprovePayment"
                v-on:onPaymentSelected="onPaymentSelected"
              />
            </b-col>
            <b-col class="payment-image">
              <PaymentImage
                :paymentSelected="paymentSelected"
                :isCanEdit="canEdit"
                v-on:onDeleteImage="onDeleteImage"
              />
            </b-col>
            <b-col class="payment-detail">
              <PaymentDetailForm
                :bankAccountList="bankAccountList"
                :paymentSelected="paymentSelected"
                :invoiceNo="invoiceNo"
                :orderTotalAmount="orderTotalAmount"
                :isCanEdit="canEdit"
                :v="$v.formApprovePayment.$each.$iter[paymentSelectedIndex]"
              />
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-4" v-if="canEdit">
        <div class="ml-2">
          <b-button
            class="w-100 btn-main-4"
            @click="onCheckformReject"
            :disabled="isDisable"
            >ปฏิเสธ</b-button
          >
        </div>
        <div class="ml-2">
          <b-button
            class="w-100 btn-main"
            @click="onCheckformApprove"
            :disabled="isDisable"
            >ยืนยัน</b-button
          >
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4" v-if="!canEdit">
        <div class="ml-2">
          <b-button class="w-100 btn-main" @click="hide">ตกลง</b-button>
        </div>
      </div>
    </b-modal>
    <ModalRejectPayment
      ref="modalRejectPayment"
      v-on:submitRejectPayment="onRejectPayment"
    />
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required, minValue } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import PaymentList from "../payment/PaymentList.vue";
import PaymentImage from "../payment/PaymentImage.vue";
import PaymentDetailForm from "../payment/PaymentDetailForm.vue";
import ModalRejectPayment from "./ModalRejectPayment.vue";
export default {
  components: {
    PaymentList,
    PaymentImage,
    PaymentDetailForm,
    ModalRejectPayment,
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  props: {
    orderId: {
      required: true,
      type: [Number, String],
    },
    invoiceNo: {
      required: true,
      type: String,
    },
    orderTotalAmount: {
      required: true,
      type: Number,
    },
    isCanEdit: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      modalShow: false,
      paymentSelectedIndex: 0,
      paymentDetailList: [],
      formApprovePayment: [],
      formRejectPayment: {
        ReasonId: 0,
        Note: "",
      },
      bankAccountList: [],
      modalMessage: "",
      isDisable: false,
      paymentSelected: {},
      canEdit: true
    };
  },
  validations: {
    formApprovePayment: {
      $each: {
        bankAccountId: {
          required,
        },
        amount: {
          required,
        },
        paymentDate: {
          required,
        },
        note: {},
        imageUrl: { required },
      },
    },
  },
  async created () {
    if(this.isCanEdit) {
      let permissionsList = this.$store.getters.getUserPermissionsList();
      let currentBrandID = this.$route.query.brandID;
      let permissionListByBrandId = await permissionsList.filter((el) => {
        return el.brandId == currentBrandID;
      });
      if(permissionListByBrandId.length > 0) this.canEdit = permissionListByBrandId[0].permission.indexOf(37) != -1;
    } else this.canEdit = this.isCanEdit;
  },
  methods: {
    onDeleteImage() {
      this.paymentSelected.imageUrl = "";
    },
    onPaymentSelected(payment, paymentSelectedIndex) {
      this.paymentSelected = payment;
      this.paymentSelectedIndex = paymentSelectedIndex;
      this.paymentSelected.note = "";
    },
    getPaymentDetail: async function () {
      await this.axios
        .get(`${this.$baseUrl}/transaction/${this.orderId}/transferList`)
        .then(async (data) => {
          this.paymentDetailList = data.detail;
          this.paymentSelected = data.detail[0];
          await this.getBankList();
          this.paymentDetailList.forEach((element) => {
            let paymentDate = `${element.transferDate.substring(0, 10)}T${
              element.transferTime
            }`;
            this.formApprovePayment.push({
              id: element.id,
              bankAccountId: element.bankAccountId,
              amount: element.amount,
              paymentDate: paymentDate,
              note: "",
              imageUrl: element.imageUrl,
            });
          });
        });
    },
    getBankList: async function () {
      await this.axios
        .get(
          `${this.$baseUrl}/transaction/bankaccount?transactionId=${this.orderId}`
        )
        .then((data) => {
          this.bankAccountList = data.detail;
          if (this.paymentSelected.bankAccountId == 0) {
            this.paymentSelected.bankAccountId = this.bankAccountList[0].id;
          }
        });
    },
    onCheckformReject() {
      this.$refs.modalRejectPayment.show();
    },
    onCheckformApprove() {
      let paymentDate = `${this.paymentSelected.transferDate.substring(
        0,
        10
      )}T${this.paymentSelected.transferTime.substring(11, 19)}`;

      this.formApprovePayment[this.paymentSelectedIndex].amount =
        this.paymentSelected.amount;
      this.formApprovePayment[this.paymentSelectedIndex].paymentDate =
        paymentDate;
      this.formApprovePayment[this.paymentSelectedIndex].imageUrl =
        this.paymentSelected.imageUrl;
      this.formApprovePayment[this.paymentSelectedIndex].note =
        this.paymentSelected.note;

      this.$v.formApprovePayment.$touch();
      if (this.$v.formApprovePayment.$error) {
        return;
      }

      this.onApprovePayment();
    },
    onApprovePayment: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .put(`${this.$baseUrl}/transaction/${this.orderId}/approve`, {
          paymentList: this.formApprovePayment,
        })
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    onRejectPayment: async function (form) {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .put(`${this.$baseUrl}/transaction/${this.orderId}/reject`, form)
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalRejectPayment.hide();
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    hadleModalAlertClose() {
      this.hide();
      this.$emit("onRefreshData");
    },
    show: async function () {
      this.formApprovePayment = [];
      this.$v.formApprovePayment.$reset();
      await this.getPaymentDetail();
      this.modalShow = true;
    },
    hide() {
      this.modalShow = false;
    },
  },
};
</script>

<style lang="scss"  scoped>
/deep/ .header-payment {
  background: #eae2f3;
}
.payment-list,
.payment-image,
.payment-detail {
  height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
